<template>
  <div>
      <img :src="file.preview" class="thumbnail">
        <div>
            {{file.file.name}}
        </div>
  </div>
</template>

<script>
export default {
    props:["file"]
}
</script>

<style>

</style>